import { request } from "./apiClient";
import type {
  MerchantAliasListResponse,
  UpsertMerchantAliasResponse,
} from "@boo/shared";

export async function upsertAlias(
  rawName: string,
  alias: string,
): Promise<UpsertMerchantAliasResponse> {
  return request<UpsertMerchantAliasResponse>("/merchant-aliases", {
    method: "PUT",
    data: { rawName, alias },
  });
}

export async function getAliasMap(): Promise<Record<string, string>> {
  const items = await request<{ rawName: string; alias: string }[]>(
    "/merchant-aliases/alias-map",
  );
  return Object.fromEntries(items.map((item) => [item.rawName, item.alias]));
}

export async function getMerchantAliasesList(
  page = 1,
  pageSize = 20,
): Promise<MerchantAliasListResponse> {
  return request<MerchantAliasListResponse>(
    `/merchant-aliases?page=${page}&pageSize=${pageSize}`,
  );
}
